import { render } from "./Faculties.vue?vue&type=template&id=0a368b7a&scoped=true"
import script from "./Faculties.vue?vue&type=script&lang=js"
export * from "./Faculties.vue?vue&type=script&lang=js"

import "./Faculties.vue?vue&type=style&index=0&id=0a368b7a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a368b7a"

export default script